export default __webpack_public_path__ + "static/media/columbia.f3ab750b.jpg";